import {LinkService} from '../../i18n/link.service'
import {validateDatoCmsTypes} from './common.serde'
import {parseServicesSection} from './services-section.serde'
import {parseSupportSection} from './support-section.serde'
import {parsePartnerSection} from './partner-section.serde'
import {parsePageMeta} from './seo.serde'
import {ServiceOverviewPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {ServiceOverviewPage} from '../types/service-overview-page.types'

export function parseServiceOverviewPage(
  linkService: LinkService,
  e: ServiceOverviewPageFieldsFragment,
): ServiceOverviewPage {
  const entry = validateDatoCmsTypes(e)
  const {availableLanguages, canonicalUrl} = parsePageMeta(linkService, entry.seo, e._locales)

  return {
    plot: entry.plot,
    title: entry.title,
    description: entry.description,
    doNotIndexPage: entry.seo?.doNotIndexPage || false,
    servicesSection: parseServicesSection(e.servicesSection)!,
    supportSection: parseSupportSection(e.supportSection!),
    partnerSection: e.partnerSection ? parsePartnerSection(linkService, e.partnerSection) : undefined,
    canonicalUrl: canonicalUrl ? canonicalUrl : undefined,
    availableLanguages: availableLanguages ? availableLanguages : [],
  }
}
